module.exports = __webpack_public_path__ + "img/w3_circle_up_black.ae13a5f0.ae13a5f0.png";